import React from "react"

import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import ArrowLink from "../components/ArrowLink"
import SectionWrap from "../components/SectionWrap"
import Button from "../components/CTAButton"
import Img from "gatsby-image"
import Slider from "../components/Slider"
import ArticleCard from "../components/ArticleCard"
import PressCard from "../components/PressCard"
import FadeIn from "../components/FadeIn"

import "../styles/page-home.scss"
import mountainsMp4 from "../video/mountains.mp4"
import mountainsWebM from "../video/mountains.webm"
import VideoPlayer from "../components/VideoPlayer"

export default ({ pageContext, data }) => {
  const meta = pageContext.seo
  let articleSlides = data.allWpNewsArticle.edges.map(article => {
    return (
      <PressCard
        categories={article.node.categories}
        key={article.node.title}
        title={article.node.title}
        slug={article.node.newsArticles.link}
        external={true}
      />
    )
  })
  let pressSlides = []
  data.allWpPost.group.map(group => {
    if (group.fieldValue === "featured") {
      pressSlides = group.edges.map(post => (
        <ArticleCard
          categories={post.node.categories}
          key={post.node.title}
          title={post.node.title}
          image={
            post.node.featuredImage !== null
              ? post.node.featuredImage.node.localFile.childImageSharp.fluid
              : null
          }
          slug={post.node.slug}
          showImage={false}
        />
      ))
    }
    return null
  })
  const copy = data.allWpPage.edges[0].node.homePage
  return (
    <Layout className="homePage">
      <Seo title={meta.title} description={meta.metadesc} />
      <SectionWrap className="landing sectionWrap">
        <div className="landingCopyContainer">
          <FadeIn>
            <h2
              className="mainTitle"
              dangerouslySetInnerHTML={{ __html: copy.landingCopy.header }}
            />
          </FadeIn>
          <div className="videoWrapper heroVideo hideMobile">
            <video
              loop
              poster={data.heroImage1.childImageSharp.fluid.src}
              className="video"
              muted
              autoPlay={true}
            >
              <source
                src={mountainsWebM}
                type='video/webm;codecs="vp8, vorbis"'
              />
              <source
                src={mountainsMp4}
                type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"'
              />
            </video>
          </div>
          <Img
            className="heroImage hideTablet hideDesktop"
            fluid={data.heroImage1.childImageSharp.fluid}
          />
          <div className="copyContainer hideTablet">
            {copy.landingCopy.subheader !== "" ? (
              <FadeIn>
                <h5 className="smallTitle">{copy.landingCopy.subheader}</h5>
              </FadeIn>
            ) : null}
            <FadeIn>
              <p className="landingCopy large">{copy.landingCopy.text}</p>
            </FadeIn>
            <FadeIn>
              <p className="landingCopy">{copy.landingCopy.subText}</p>
            </FadeIn>
            <FadeIn>
              <ArrowLink className="workButton" href="/about/" color="black">
                About Us
              </ArrowLink>
            </FadeIn>
          </div>
        </div>
      </SectionWrap>
      <section className="hideMobile hideDesktop workWithUs">
        <h2 className="hidden">Work With Us Info</h2>
        <FadeIn>
          <h5 className="smallTitle">{copy.landingCopy.subheader}</h5>
        </FadeIn>
        <FadeIn>
          <p className="landingCopy large">{copy.landingCopy.text}</p>
        </FadeIn>
        <FadeIn>
          <p className="landingCopy">{copy.landingCopy.subText}</p>
        </FadeIn>
        <FadeIn>
          <ArrowLink className="workButton" href="/contact/" color="black">
            Work With Us
          </ArrowLink>
        </FadeIn>
      </section>
      {/* <SectionWrap
        className="featuredText"
        title="Our Principles"
        showTitle={false}
      >
        <div className="textWrapper">
          <FadeIn threshold={0.1}>
            <h3 className="subheader">{copy.featuredText.header}</h3>
          </FadeIn>
        </div>
      </SectionWrap> */}
      {/*video section starts here */}
      <SectionWrap className="featuredVideo">
        {copy.featuredVideo.title && (
          <FadeIn>
            <h2 className="mainTitle">{copy.featuredVideo.title}</h2>
          </FadeIn>
        )}
        <VideoPlayer
          videoId={copy.featuredVideo.id}
          videoHash={copy.featuredVideo.hash}
          posterSrc={copy.featuredVideo.thumbnail.sourceUrl}
          posterSrcSet={copy.featuredVideo.thumbnail.srcSet}
          //posterSrc={data.heroImage3.childImageSharp.fluid.src}
        />
      </SectionWrap>

      {/*video section ends here */}
      <SectionWrap className="teamSection" title={"Our Team"} showTitle={false}>
        <Img
          className="heroImage"
          fluid={data.heroImage2.childImageSharp.fluid}
        />
        <div className="teamCopyContainer">
          <FadeIn>
            <h4 className="smallTitle">Our Team</h4>
          </FadeIn>
          <FadeIn>
            <h3 className="subheader">{copy.ourTeamSection.header}</h3>
          </FadeIn>
          <FadeIn>
            <p className="text">{copy.ourTeamSection.text}</p>
          </FadeIn>
          <FadeIn animation="fade">
            <Button href="/team/">{copy.ourTeamSection.buttonText}</Button>
          </FadeIn>
        </div>
      </SectionWrap>
      <SectionWrap className="mediaSection sectionWrap">
        <span className="sectionHeadingWrapper">
          <FadeIn>
            <h2 className="sectionIdentifier">{copy.mediaSection.header}</h2>
          </FadeIn>
          <span className="divider" />
        </span>
        <div className="pressSection">
          <FadeIn>
            <h3 className="subheader">
              {copy.mediaSection.pressReleases.header}
            </h3>
          </FadeIn>
          <Slider slides={pressSlides} />
          <FadeIn animation="fade">
            <Button href="/media/">
              {copy.mediaSection.pressReleases.buttonText}
            </Button>
          </FadeIn>
        </div>
        <div className="articlesSection">
          <FadeIn>
            <h3 className="subheader">{copy.mediaSection.articles.header}</h3>
          </FadeIn>
          <Slider slides={articleSlides} />
          <FadeIn animation="fade">
            <Button href="/media/#media-link" color="white">
              {copy.mediaSection.articles.buttonText}
            </Button>
          </FadeIn>
        </div>
      </SectionWrap>
      <SectionWrap className="homeContact">
        <div className="contactInner">
          <FadeIn>
            <h2 className="mainTitle">{copy.workWithUsSection.header}</h2>
          </FadeIn>
          <div className="contactContainer contactContainerLeft">
            <FadeIn>
              <h3 className="subheader">
                {copy.workWithUsSection.jobsLink.header}
              </h3>
            </FadeIn>
            <FadeIn>
              <ArrowLink href="/careers/" color="white">
                {copy.workWithUsSection.jobsLink.buttonText}
              </ArrowLink>
            </FadeIn>
          </div>
          <div className="contactContainer">
            <FadeIn>
              <h3 className="subheader">
                {copy.workWithUsSection.contactLink.header}
              </h3>
            </FadeIn>
            <FadeIn>
              <ArrowLink href="/contact/" color="white">
                {copy.workWithUsSection.contactLink.buttonText}
              </ArrowLink>
            </FadeIn>
          </div>
        </div>
      </SectionWrap>
    </Layout>
  )
}

export const query = graphql`
  query {
    heroImage1: file(relativePath: { eq: "home-hero-1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 90) {
          src
          ...GatsbyImageSharpFluid
        }
      }
    }
    heroImage2: file(relativePath: { eq: "home-hero-2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 90) {
          src
          ...GatsbyImageSharpFluid
        }
      }
    }
    heroImage3: file(relativePath: { eq: "video-image.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 90) {
          src
          ...GatsbyImageSharpFluid
        }
      }
    }
    allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { slug: { eq: "featured" } } } }
      }
      limit: 3
    ) {
      group(limit: 3, field: categories___nodes___slug) {
        fieldValue
        edges {
          node {
            categories {
              nodes {
                id
                slug
              }
            }
            slug
            title
            featuredImage {
              node {
                slug
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    allWpNewsArticle(sort: { fields: date, order: DESC }, limit: 3) {
      edges {
        node {
          title
          newsArticles {
            link
          }
        }
      }
    }
    allWpPage(filter: { slug: { eq: "home" } }) {
      edges {
        node {
          id
          homePage {
            landingCopy {
              header
              subheader
              text
              subText
            }
            featuredVideo {
              title
              id
              hash
              thumbnail {
                sourceUrl
                srcSet
              }
            }
            ourTeamSection {
              header
              text
              buttonText
            }
            mediaSection {
              header
              articles {
                header
                buttonText
              }
              pressReleases {
                header
                buttonText
              }
            }
            workWithUsSection {
              header
              jobsLink {
                header
                buttonText
              }
              contactLink {
                header
                buttonText
              }
            }
          }
        }
      }
    }
  }
`
